import { DatePipe, CurrencyPipe } from '@angular/common';
import { ApiPolicyEditResponse } from '@bhtp-client-api/edit';
import { ApiPolicy, DateInformation, DateParts } from '@bhtp-client-api/base';
import { PolicyDetailViewModel } from '@bhtp-client-web/component';

export class PolicyDetails extends PolicyDetailViewModel {

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/policy-edit/view-models/policy-details.model.ts